import { camelToSnakeCase } from "common/utils/helpers/cases";

export const deepFlattenObject = (
  obj: any,
  keyNameDelimiter = "_",
  prefix = ""
): Record<string, any> => {
  const flattened: Record<string, any> = {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const snakeKey = camelToSnakeCase(key);
      const newKey = prefix ? `${prefix}${keyNameDelimiter}${snakeKey}` : snakeKey;
      const value = obj[key];

      if (value !== null && typeof value === "object") {
        if (Array.isArray(value)) {
          // Handle arrays by using indices
          value.forEach((item, index) => {
            const arrayKey = `${newKey}${keyNameDelimiter}${index}`;
            if (item !== null && typeof item === "object") {
              Object.assign(flattened, deepFlattenObject(item, keyNameDelimiter, arrayKey));
            } else {
              flattened[arrayKey] = item;
            }
          });
        } else {
          // Handle nested objects
          Object.assign(flattened, deepFlattenObject(value, keyNameDelimiter, newKey));
        }
      } else {
        flattened[newKey] = value;
      }
    }
  }

  return flattened;
};
